import { render, staticRenderFns } from "./search.vue?vue&type=template&id=3243453b&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3243453b')) {
      api.createRecord('3243453b', component.options)
    } else {
      api.reload('3243453b', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=3243453b&", function () {
      api.rerender('3243453b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captains/wallet/transactions/partials/search.vue"
export default component.exports